import { gql, useQuery } from "@apollo/client";

// Empower Me Bundles

export function useEmpowerMeBundlesWithDetails() {
  return useQuery(
    gql`
      query getEmpowerMeBundlesWithDetails {
        empower_me_bundles {
              _id 
              name
              description
              status
              bundle_category_id
              tasks {
                  empower_me_task_id
                  empower_me_task_details {
                      _id
                      name
                      description
                      image_id
                  }
              }
          }
      }
    `
  );
}

export function useEmpowerMeBundlesActiveOnly() {
  return useQuery(
    gql`
      query getEmpowerMeBundlesActiveOnly {
        empower_me_bundles_actives {
              _id 
              name
              description
              bundle_category_id
              tasks {
                  empower_me_task_details {
                      _id
                      name
                      description
                      image_id
                  }
              }
          }
      }
    `
  );
}

export function useEmpowerMeBundlesActiveAndForUserOnly() {
  return useQuery(
    gql`
      query getEmpowerMeBundlesActiveAndForUserOnly {
        empower_me_bundles_for_user {
              _id 
              name
              description
              bundle_category_id
              tasks {
                  empower_me_task_details {
                      _id
                      name
                      description
                      image_id
                      task_category {
                        description
                        image
                      }
                  }
              }
          }
      }
    `
  );
}

export function useEmpowerMeBundlesCategories() {
  return useQuery(
    gql`
      query getEmpowerMeBundlesCategories {
        empower_me_bundle_categories {
              _id 
              name
              description
              status
              level
              parent_id
              image_id
          }
      }
    `
  );
}

export function useEmpowerMeBundlesCategoriesActive() {
  return useQuery(
    gql`
      query getEmpowerMeBundlesCategoriesActive {
        empower_me_bundle_categories_actives {
              _id 
              name
              description
              status
              level
              parent_id
              image_id
          }
      }
    `
  );
}